import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Faqs = () => {
  return (
    <Grid
      id="faqs"
      container
      direction="column"
      spacing={2}
      sx={{
        p: 2,
        mb: 10,
        mt: 5,
        width: "95%",
        mx: "auto",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid item>
        <Typography
          align="center"
          sx={{ fontWeight: "bold", mb: 2, fontSize: 30 }}
        >
          FAQ's
        </Typography>
      </Grid>

      {[
        {
          question: " Why should I choose Podar Prep?",
          answer:
            "Podar Prep is the best preschool as it has a unique philosophy of 'KIDUCATION' meaning 'education from the child's point of view' that caters to the growth and developmental needs and happiness quotient of your child. We provide real-life, sensory and engaging learning environments to foster collaborative learning focusing on life skills to promote sustainable and lifelong learners.",
        },
        {
          question: "How much is the average fee for a preschool near me?",
          answer:
            "The fee structure depends on the preschool near you as it differs from area to area, depending on various factors. Hence, kindly contact the nearest Podar Prep to know about it in detail or fill out the enquiry form on the website and our representative will get in touch with you to answer your queries.",
        },
        {
          question: "What is the age for playgroup admission in Yelahanka?",
          answer:
            "85% of a child's cumulative brain development occurs prior to the age of 6. Hence, at Podar Prep we provide optimal stimulation for energising the brain cells to shape the behaviour, emotions and development of each child as per the respective age group. The age for Playgroup admission is 2-3 years, Nursery (3-4 years), Junior Kindergarten (4-5 years), and Senior Kindergarten (5-6 years) to build a strong foundation for your child's future.",
        },
        {
          question: "Which curriculum is followed in the best PreSchool?",
          answer:
            "Various preschools follow various curriculum approaches. Podar Prep Preschool is equipped with 3 different international curriculums. It is powered by NEP 2020 with the development and learning of the Early Years Foundation Stage (EYFS-UK) and life skills learning from the Early Years Learning Framework (EYLF-Australia) to have the best start for your children's educational journey!",
        },
      ].map((faq, index) => (
        <Grid item key={index} sx={{ width: "100%" }}>
          <Accordion sx={{ border: "3px solid #1d67ab" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
              sx={{
                backgroundColor: "#1d67ab",
                color: "#fff",
                fontWeight: "bold",
                height: 60,
                "& .MuiAccordionSummary-content": {
                  fontWeight: "bold",
                },
              }}
            >
              <Typography sx={{ fontWeight: "bold", fontSize: 16 }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "#ffffff" }}>
              <Typography>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
    </Grid>
  );
};

export default Faqs;

